import $ from 'jquery';
import 'slick-carousel';

export const init = ($target) => {

	$target.find('.c-ambasadors').each(function () {

		var $this = $(this);
		var $list = $this.find('.c-ambasadors__list');
		var $prev = $this.find('.c-ambasadors__prev');
		var $next = $this.find('.c-ambasadors__next');
		var $select = $this.find('select');

		$select.on('change', () => {
			const value = $select.val();
			$list.slick('slickUnfilter');
			if (value === 'all') return;
			$list.slick('slickFilter', function() {
				return $(this).find(`.c-ambasadors__item[data-attribute="${value}"]`).length > 0;
			});
		});

		$list
			.slick({
				infinite: false,
				prevArrow: $prev,
				nextArrow: $next,
				cssEase: 'ease-out',
				centerMode: false,
			});

	});
};
